import React from 'react';

export interface UnderlineScribbleProps {
  fill?: string;
}

export const UnderlineScribble: React.FC<UnderlineScribbleProps> = ({ fill }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 2361 160'
      fill={`${!!fill?.length ? fill : '#000'}`}>
      <path d='M2237.69 133.47c-10.45-2.38-16.47-3.57-75.56-15.7-36.43-7.48-12.36-3.16-118.16-20.49-25.59-4.19 0-.71-135.07-17.85-8.95-1.15-133.68-12.6-151.72-13.63l-135.35-7.69c-193.33-4.46-121.19-3.6-316.88-3.58-5.92 0-11.84.18-17.76.27-180.73 2.85-116.32 1.34-301.53 7.23-221.28 7.03-694.46 42.67-830.09 43.22-129.83.53-140.53-4.2-146.67-.68v.02l.24-.13-.26.26a5.69 5.69 0 0 1-.78 2.35c-.6.88-.93.86-1.52.66-1.82-.57-2.92-2.94-3.65-4.5A31.15 31.15 0 0 1 .25 92.5c-.17-2.23-.52-4.69.12-6.89.61-2.09 2.33-2.93 4.17-3.75 8.54-2.42 30.23 2.45 134.92 1.4C293.5 81.74 656.89 44.11 819.7 32.02c179.99-13.37 117.73-9.19 296.2-19.85 19.99-1.19 175.94-7.73 176.04-7.73C1473.81-.34 1449.39.2 1473.91.2c161.79-.23 117.29-.81 207.74 2.22 97.59 3.26 41.64.18 204.67 11.46 5.69.39.79-.08 117.46 12.67 11.42 1.25 12.31 1.49 65.86 9.6 56.03 8.49 48.84 7.21 66.4 10.75 86.59 17.42 69.93 13.21 203.89 45.35 1.81.63 3.34 1.69 4.59 3.16 15.37 17.11 21.01 64.2 9.11 64.2-.7 0-.24.22-115.95-26.14Z'>
      </path>
    </svg>
  );
};

export default UnderlineScribble;
